import { ObservableArray, View } from "binder"
import { InterfacePersonForSelector, InterfacePersonSearchViewModel } from "./interfacePersonSearch-viewModel";

export class InterfacePersonSearchView extends View<InterfacePersonSearchViewModel>{
    GetViewUniqueId(): string {
        return "V-E4F377B3-D777-4D58-823F-525E068D0660"
    }
    loadHtml(): string {
        let element = require('./interfacePersonSearch.html').default;
        let style = require('./interfacePersonSearch.less');
        return element;
    }
    constructor() {
       super();
    }
    
    public set items(v: ObservableArray<InterfacePersonForSelector>) { this._items = v; } public get items(): ObservableArray<InterfacePersonForSelector> { return this._items;} private _items: ObservableArray<InterfacePersonForSelector>;
    public set selectedItem(v: InterfacePersonForSelector) { this._selectedItem = v; } public get selectedItem(): InterfacePersonForSelector { return this._selectedItem;} private _selectedItem: InterfacePersonForSelector;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set searchedText(v: string) { this._searchedText = v; } public get searchedText(): string { return this._searchedText;} private _searchedText: string;
    public set isShowingPopup(v: boolean) { 
        this._isShowingPopup = v;
        if(v && this.popup_container)
            this.preferredWidth = this.popup_container.clientWidth.toString()+"px";
    } public get isShowingPopup(): boolean { return this._isShowingPopup;} private _isShowingPopup: boolean;
    public set preferredWidth(v: string) { this._preferredWidth = v; } public get preferredWidth(): string { return this._preferredWidth;} private _preferredWidth: string;
    public set popup_container(v: HTMLElement) { this._popup_content = v; } public get popup_container(): HTMLElement { return this._popup_content;} private _popup_content: HTMLElement;
    
    
    onkeydown(e:KeyboardEvent){
        if(e.key=="Enter"){
            this.refresh();
        }
    }
    public onRenderCompleted() {
        this.popup_container = this.firstlevelElement.querySelector("#V-41490DFA-051F-45BA-88F0-AFD2585640E0-popup-container");
        this.preferredWidth = this.popup_container.clientWidth.toString()+"px";
    }
    refresh(){
        this.dataContext.runLast();
    }

}
